import { FC } from 'react';

import { EvSpinner } from '@evinced-private/ui-common';

// Redirect URI target for the Azure (MSAL) sign-in popup. MSAL completes the handshake
// from the opener window, so this page only renders briefly while the popup lands here.
export const AzureAuthenticationPage: FC = () => <EvSpinner />;
